<template>
  <div class="about">
        <section class="banner_area">
            <div class="banner_inner d-flex align-items-center">
                <div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
                <div class="container">
                    <div class="banner_content text-left">
                        <div class="page_link">
                            <router-link to="/"><a>Home</a></router-link>
                            <router-link to="/contact"><a>Contact</a></router-link>
                        </div>
                        <h2 style="color: black;">Welcome to GitLeaf Support</h2>
                    </div>
                </div>
            </div>
        </section>
        <!--================ End Pricing Banner Area =================-->
        
        <!--================Contact Area =================-->
        <section class="contact_area section_gap">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3" data-aos="fade-up">
                        <div class="contact_info">
                            <div class="info_item">
                                <i class="lnr lnr-home"></i>
                                <h6>Batticaloa, Sri Lanka 🇱🇰</h6>
                                <p>Mandapathady, Kannankudah.</p>
                            </div>
                            <div class="info_item">
                                <i class="lnr lnr-phone-handset"></i>
                                <h6><a href="#">+94 (77) 9313 495 📲</a></h6>
                                <p>Whatsapp only</p>
                            </div>
                            <div class="info_item">
                                <i class="lnr lnr-envelope"></i>
                                <h6><a href="mailto:contact@gitleaf.com">contact@gitleaf.com 📧</a></h6>
                                <p>Send us your query anytime!</p>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-9" data-aos="fade-up">
                        <h3 style="color: black;">GET A QUOTE & CONTACT FORM</h3>
                        <div class="row contact_form">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="input.name" id="name" name="name" placeholder="Enter your name">
                                </div>
                                <div class="form-group">
                                    <input type="email" class="form-control" v-model="input.email" id="email" name="email" placeholder="Enter email address">
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="input.phone" id="phone" name="phone" placeholder="Enter Phone Number">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <textarea class="form-control" v-model="input.msg" name="message" id="message" rows="1" placeholder="Enter Message"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12 text-right">
                                <button type="buuton" v-on:click="message()" class="primary_btn"><span>Send Message</span></button>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="container" data-aos="fade-up">
                <div class="row">
                    <div class="col-lg-8">
                      <h3 style="color: black; text-transform: uppercase;"> Community Forum </h3>
                      <ul>
                        <li>
                          Join Discord <a target="_blank" href="https://discord.gg/Kkq6tW"><img height="60" src="img/discord-icon.png"/></a>
                        </li>
                        <!-- <li>
                          Chat WhatsApp <a target="_blank" href="https://wa.me/94776312777"><img src="img/whatsapp-business.png" height="50"></a>
                        </li> -->
                      </ul>
                      
                    </div>
                </div>
            </div>
        </section>
        <!--================Contact Area =================-->
  
  <Footer/>

  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";
import axios from 'axios';


export default {
  name: "Home",
  components: {
    Footer
  },
  data() {
      return {
         input:{
            subscribe : "",
            name : "",
            email: "",
            phone: "",
            msg: ""
         } 
      };
   },
   created () {
      localStorage.setItem("ContactMsg", false);
   },
   methods: {
      message(){
        if (this.input.name != "" && this.input.email != "" && this.input.phone != "" && this.input.msg != "") {
          if(this.validateEmail(this.input.email))
          {
            var ContactMsg = localStorage.getItem("ContactMsg");
            if (ContactMsg == "false") {
              axios({
                method: 'get',
                url: 'https://gl-mail.herokuapp.com/api/message?name='+this.input.name+'&email='+this.input.email+'&phone='+this.input.phone+'&message='+this.input.msg,
              })
              .then(response => {
                
                this.showAlert(response.data.message);
                localStorage.setItem("ContactMsg", true);
                this.input.name = "";
                this.input.email = "";
                this.input.phone = "";
                this.input.msg = "";
              })
              .catch(() => console.log('error occured'))

            } else {       
              this.$toasted.show("You have already sent an inqurey", { 
                theme: "toasted-primary", 
                position: "top-right", 
                duration : 5000
              });
            }
          }
          else
          {
            this.$toasted.show("Invalid Email Address", { 
              theme: "toasted-primary", 
              position: "top-right", 
              duration : 5000
            });
          }
        }
        else
        {
            this.$toasted.show("Please fillout the form before submit.", { 
               theme: "toasted-primary", 
               position: "top-right", 
               duration : 5000
            });
        }
      },
      showAlert(message){
        this.$toasted.show(message, { 
           theme: "toasted-primary", 
           position: "top-right", 
           duration : 5000
        });
      },
      validateEmail(value){
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value))
        {
          return true;
        } 
        else
        {
          return false;
        } 
      }
   }
};
</script>
